class FAQSection {
  constructor(container) {
    this.container = container;
    this.triggers = this.container.querySelectorAll(".js-faq-trigger");
    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => this.toggleTab(e.currentTarget));
    });
  }

  toggleTab(trigger) {
    const item = trigger.closest(".faq-section__item");
    const isExpanded = trigger.getAttribute("aria-expanded") === "true";

    if (!isExpanded) {
      item.classList.add("faq-section__item--active");
      trigger.setAttribute("aria-expanded", "true");
    } else {
      item.classList.remove("faq-section__item--active");
      trigger.setAttribute("aria-expanded", "false");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const faqSections = document.querySelectorAll(".faq-section");
  faqSections.forEach((section) => new FAQSection(section));
});
